import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import { toast } from "react-toastify";
import { mask, unMask } from "remask";
import { useAuth } from "../contexts/AuthInfoContext";
import { Api } from "../services/Api";

function AtualizarDadosDialog(props) {
  const regEmail = new RegExp("^[\\w-\\.]+@([\\w-]+\\.)+[\\w-]{2,4}$");
  const [emailDevedor, setEmailDevedor] = useState("");
  const [celularDevedor, setCelularDevedor] = useState("");
  const { user_id } = useAuth();

  // usuario_nome: user.usuario_nome,
  // usuario_email: user.usuario_email,
  // usuario_documento: user.usuario_documento,
  // usuario_data_nascimento: user.usuario_data_nascimento,
  // endereco_rua,
  // endereco_numero,
  // endereco_complemento,
  // endereco_bairro,
  // endereco_cidade,
  // endereco_estado,
  // endereco_cep,
  const atualizarDados = async (event) => {
    event.preventDefault();
    if (regEmail.test(emailDevedor)) {
      const dadosCliente = {
        usuario_id: user_id,
        usuario_email: emailDevedor,
        usuario_celular: unMask(celularDevedor),
      };
      try {
        await toast.promise(Api.put("/users/update_usuarios", dadosCliente), {
          pending: "Atualizando informações",
          success: "Informações atualizadas com sucesso!",
          error: "Erro ao atualizar informações",
        });
        props.close();
      } catch (error) {
        console.log(error);
      }
    } else toast.error("E-mail inválido,por favor insira um e-mail válido");
  };

  return (
    <Dialog
      visible
      onHide={() => props.close()}
      header="Atualização Cadastral"
      style={{
        heigth: window.innerHeight > 900 ? "50vh" : "90vh",
        width: window.innerWidth > 900 ? "60vw" : "100vw",
        textAlign: "left",
        //borderRadius: '30px',
      }}
      className="boletosDialog"
    >
      <div className="p-[2vh]">
        <h5>Atualize seus dados por gentileza para garantir um melhor atendimento e experiência na nossa plataforma</h5>
        <form onSubmit={(e) => atualizarDados(e)}>
          <div className="flex gap-8 justify-center mt-8 mb-8">
            <div className="w-full">
              <h6 className="mb-2 font-bold">Endereço de E-mail</h6>
              <InputText
                value={emailDevedor}
                onChange={(e) => setEmailDevedor(e.target.value)}
                placeholder="Digite seu e-mail"
                className="w-full"
              />
            </div>
            <div className="w-full">
              <h6 className="mb-2 font-bold">Número do Celular</h6>
              <InputText
                value={celularDevedor}
                onChange={(e) => setCelularDevedor(mask(unMask(e.target.value), ["(99) 9999-9999", "(99) 99999-9999"]))}
                placeholder="Digite o número de seu celular"
                className="w-full "
              />
            </div>
          </div>
          <div className="flex w-full justify-center">
            <div className="w-1/2">
              <Button label="Continuar" className="w-full" type="submit" />
            </div>
          </div>
        </form>
      </div>
    </Dialog>
  );
}

export default AtualizarDadosDialog;
